(function () {
  'use strict';

  // Collapsible filter groups
  document.querySelectorAll('.filter-group__head').forEach((head) => {
    head.addEventListener('click', () => {
      head.parentElement.classList.toggle('collapsed');
    });
  });

  // Mobile filter sidebar toggle
  const filterToggle = document.getElementById('FilterToggle');
  const filters = document.getElementById('Filters');
  if (filterToggle && filters) {
    // Start collapsed on mobile
    if (window.matchMedia('(max-width: 768px)').matches) {
      filters.classList.add('is-mobile-collapsed');
    }
    filterToggle.addEventListener('click', () => {
      filters.classList.toggle('is-mobile-collapsed');
    });
  }

  // Sort dropdown auto-submit
  document.querySelectorAll('.toolbar__sort select').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Filter checkbox auto-submit (Shopify uses GET filtering)
  document.querySelectorAll('form#FacetFilterForm input[type=checkbox], form#FacetFilterForm input[type=number]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      if (form) form.submit();
    });
  });

  // Price range submit on Enter or blur
  document.querySelectorAll('form#FacetFilterForm input[name^=filter][name$=gte], form#FacetFilterForm input[name^=filter][name$=lte]').forEach((input) => {
    input.addEventListener('blur', () => {
      const form = input.closest('form');
      if (form) form.submit();
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const form = input.closest('form');
        if (form) form.submit();
      }
    });
  });

  // Wishlist (visual only)
  document.querySelectorAll('.product-card__wishlist').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.toggle('is-active');
    });
  });

  // View toggle (Raster/Liste) — persists in localStorage
  const grid = document.querySelector('.product-grid--collection');
  const viewButtons = document.querySelectorAll('.toolbar__view button[data-view]');
  if (grid && viewButtons.length) {
    const saved = localStorage.getItem('dar-assalam-view') || 'grid';
    grid.classList.toggle('product-grid--list', saved === 'list');
    viewButtons.forEach((b) => b.classList.toggle('is-active', b.dataset.view === saved));

    viewButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.view;
        viewButtons.forEach((b) => b.classList.toggle('is-active', b === btn));
        grid.classList.toggle('product-grid--list', view === 'list');
        localStorage.setItem('dar-assalam-view', view);
      });
    });
  }
})();
